
import { computed, defineComponent } from 'vue'
import { parseInformNoteParts } from './audienceInformNote'

export default defineComponent({
    name: 'AudienceInformNote',
    props: {
        text: { type: String, default: '' },
    },
    setup(props) {
        const parts = computed(() => parseInformNoteParts(props.text))
        return { parts }
    },
})
